/**
 * 🎨 Resource Legend — informational HUD card explaining which
 * resource each hero uses in combat.
 *
 * Backed by canon:
 *   - /app/memory/HERO_RESOURCE_SYSTEMS_INDEX_FEB2026.md
 *   - /app/memory/CASSANDRA_LEDGER_CANON_FEB2026.md
 *
 * Read-only, cosmetic. No API calls. Collapses to a small pill until clicked.
 */
import { useState } from "react";

const RESOURCES = [
  { icon: "🔵", name: "Mana", cap: "100", note: "Warrior, Mage, Archer, Ash Rogue, Blue Mage, Vesper, Roc, Taylor-Nightingale, Wesley Blanks, Astraea, Glitch, Shadow, Cari" },
  { icon: "🔩", name: "Scrap / Blueprint Scrap", cap: "10", note: "Shared pool, reskinned per hero — 🔩 Scrap for Nathaniel (+5% def per stack), 📐 Blueprint Scrap for Miko (fuels Epoch-Nest sketches + workbench). Same mechanic, different name & look." },
  { icon: "🐦", name: "Bird Crackers", cap: "10", note: "Cassandra & Ledger — Swoop generates +3/hit. Gates the 7-Volume Ledger's Ledger matrix." },
  { icon: "🔥", name: "Ember (Passive)", cap: "N/A", note: "Mother Phoenix — no generator; skills self-fuel from Phoenix aura tier." },
];

export default function ResourceLegend() {
  const [open, setOpen] = useState(false);
  return (
    <div className="my-3" data-testid="resource-legend-wrap">
      <button
        onClick={() => setOpen((v) => !v)}
        className="text-[10px] uppercase tracking-widest text-neutral-400 hover:text-amber-300 border border-neutral-700/60 hover:border-amber-500/60 rounded-full px-3 py-1 transition-colors"
        data-testid="resource-legend-toggle"
      >
        {open ? "▲ Hide Resource Guide" : "▼ Hero Resource Guide"}
      </button>
      {open && (
        <div
          className="mt-2 rounded-xl border border-amber-700/40 bg-gradient-to-br from-neutral-950 to-black p-3 space-y-2"
          data-testid="resource-legend-card"
        >
          <div className="text-[10px] uppercase tracking-widest text-amber-400/80 font-black mb-1">
            🎨 Combat Resources
          </div>
          {RESOURCES.map((r) => (
            <div
              key={r.name}
              className="flex items-start gap-2 text-[11px] text-neutral-300 leading-snug"
              data-testid={`resource-row-${r.name.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <span className="text-lg leading-none">{r.icon}</span>
              <div>
                <span className="font-black text-amber-200">{r.name}</span>
                <span className="text-neutral-500"> · cap {r.cap}</span>
                <div className="text-neutral-400">{r.note}</div>
              </div>
            </div>
          ))}
          <div className="text-[9px] text-neutral-600 italic pt-1 border-t border-neutral-800">
            Scrap & Bird Crackers are canon — full runtime lands in a future patch.
          </div>
        </div>
      )}
    </div>
  );
}
